import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { HomeNav } from '../Common/Home/HomeNav';
import CIHAFiltersProvider from './Common/Filters/contexts/CIHAFiltersContext';
import { ProductionKpis } from './Common/ProductionKpis';
import ProductionTemporal from './ProductionTemporal/ProductionTemporal';
import PacientProfile from './PacientProfile/PacientProfile';
import Procedures from './Procedures/Procedures';
import Financing from './Financing/Financing';
import EstablishmentLocation from './EstablishmentLocation/EstablishmentLocation';
import Epidemiology from './Epidemiology/Epidemiology';

function DashBoardCIHA() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <CIHAFiltersProvider>
                <ReactQueryDevtools initialIsOpen={false} />
                <div className="dashboards-page">
                    <HomeNav menus={menus} />
                    <div className="services-container-dashboards">
                        <ProductionKpis />
                    </div>
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="production-temporal" replace />}
                        />
                        <Route
                            path="/production-temporal"
                            element={<ProductionTemporal />}
                        />
                        <Route
                            path="/pacient-profile"
                            element={<PacientProfile />}
                        />
                        <Route
                            path="/procedures"
                            element={<Procedures />}
                        />
                        <Route
                            path="/financing"
                            element={<Financing />}
                        />
                        <Route
                            path="/establishment-localization"
                            element={<EstablishmentLocation />}
                        />
                        <Route
                            path="/epidemiology"
                            element={<Epidemiology />}
                        />
                    </Routes>
                </div>
            </CIHAFiltersProvider>
        </QueryClientProvider>
    );
}

export default DashBoardCIHA;
